import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './MapView.css';

function MapView({ markers = [], height = 300, defaultCenter = [17.3, -62.7], defaultZoom = 13 }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const map = L.map(mapRef.current).setView(defaultCenter, defaultZoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    const layer = L.layerGroup().addTo(map);
    mapInstanceRef.current = map;
    layerRef.current = layer;

    return () => {
      map.remove();
      mapInstanceRef.current = null;
      layerRef.current = null;
    };
  }, [defaultCenter, defaultZoom]);

  useEffect(() => {
    const map = mapInstanceRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;

    layer.clearLayers();

    if (markers.length === 0) return;

    const validMarkers = markers.filter(m => Number.isFinite(m.lat) && Number.isFinite(m.lng));
    if (validMarkers.length === 0) return;

    validMarkers.forEach(m => {
      const color = m.color || '#22c55e';
      const circle = L.circleMarker([m.lat, m.lng], {
        radius: 8,
        fillColor: color,
        color: '#fff',
        weight: 2,
        opacity: 1,
        fillOpacity: 0.8
      }).addTo(layer);

      if (m.label) {
        circle.bindPopup(m.label);
      }
    });

    const bounds = L.latLngBounds(validMarkers.map(m => [m.lat, m.lng]));
    map.fitBounds(bounds, { padding: [30, 30], maxZoom: 16 });
  }, [markers]);

  return <div ref={mapRef} className="map-view" style={{ height }} />;
}

export default MapView;
